module.exports = __webpack_public_path__ + "static/img/img_chanpin_zhongxin_yunfuwu_pingtai.c6459ec9.png";